import React, { useState, useRef, useEffect } from "react";
import { Globe, Check } from "lucide-react";
import { LANGUAGES } from "@/lib/i18n";
import { useAuth } from "@/context/AuthContext";

export default function LanguageSwitcher({ compact }) {
  const { lang, setLang } = useAuth();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const current = LANGUAGES.find((l) => l.code === lang);

  useEffect(() => {
    const h = (e) => ref.current && !ref.current.contains(e.target) && setOpen(false);
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);

  return (
    <div className="relative" ref={ref}>
      <button
        data-testid="language-switcher"
        onClick={() => setOpen((o) => !o)}
        className="inline-flex items-center gap-1.5 rounded-full border border-border bg-card/60 px-3 py-1.5 text-sm font-semibold hover:border-primary/60"
      >
        <span className="text-base">{current?.flag || <Globe size={16} />}</span>
        {!compact && <span>{current?.nativeName}</span>}
      </button>
      {open && (
        <div className="abl-scroll absolute end-0 z-50 mt-2 max-h-80 w-56 overflow-y-auto rounded-xl border border-border bg-popover p-1.5 shadow-2xl">
          {LANGUAGES.map((l) => (
            <button
              key={l.code}
              data-testid={`lang-option-${l.code}`}
              onClick={() => {
                setLang(l.code);
                setOpen(false);
              }}
              className="flex w-full items-center gap-2.5 rounded-lg px-3 py-2 text-start text-sm hover:bg-white/5"
            >
              <span className="text-base">{l.flag}</span>
              <span className="flex-1 font-semibold">{l.nativeName}</span>
              {l.code === lang && <Check size={15} className="text-primary" />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
